





















import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class AccountLeftNav extends Vue {
  @Prop()
  private cState: any;
}
